<template>
  <q-dialog :visible="isVisible" :title="title" width="80vw" :innerScroll="false" @close="onCancel" :showFooter="false" @cancel="onCancel">
    <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px" size="mini" v-loading="loading">
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品编码:">
            {{ rowData.goodsCode }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品名称:">
            {{ rowData.goodsName }}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-table
            stripe
            border
            :header-cell-style="{ backgroundColor: '#F4F8FB' }"
            highlight-current-row
            :data="tableData.list"
            :height="300"
            v-loading="loading"
          >
            <el-table-column :show-overflow-tooltip="true" prop="promotionPriceA" label="S级活动到手价" width="120" v-if="tableProp.includes('promotionPriceA')"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="promotionPriceB" label="A级活动到手价" width="120" v-if="tableProp.includes('promotionPriceB')"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="promotionPriceC" label="日常活动到手价" width="120" v-if="tableProp.includes('promotionPriceC')"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="dailyRetailPrice" label="A类价" width="60" v-if="tableProp.includes('dailyRetailPrice')"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="tagPrice" label="产品标价(划线价)" width="130" v-if="tableProp.includes('tagPrice')"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="clearancePrice" label="清仓销售价" width="100" v-if="tableProp.includes('clearancePrice')"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="actualExecPrice" label="商品实际执行价格" width="140"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeOne" label="一段红包" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeTwo" label="二段红包" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeThree" label="三段红包" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="liveVerifyPrice" label="达播核价" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="liveCommission" label="达播佣金" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="liveControlPrice" label="达播控价" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="validityDateSection" label="有效期" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="adjustmentCause" label="调整原因"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="updateBy" label="更新人" width="90"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="updateDate" label="更新时间" width="160"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
    columnData: Array,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '调整记录';
    },
    tableProp() {
      return this.columnData.map(v=>v.columnName)
    }
  },
  data() {
    return {
      loading: false,
      editForm: {},
      rules: {},
      tableData: [],
      reportName: 'productWholePriceModifyInfo',
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true;
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: 'goodsPriceAdjustmentLog',
        queryMatch: [
          {
            attributeName: 'goodsCode',
            val: this.rowData.goodsCode,
            op: '=',
          },
        ],
        hasCount: 'Y',
      };
      axios
        .post(`/ec-pc-api/custom/reports/data/goodsPriceAdjustmentLog`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
      // let data = {
      //   pageSize: this.tableData.pageSize,
      //   pageNum: this.tableData.pageNum,
      //   reportCode: this.reportName,
      //   param: {},
      //   queryMatch: [
      //     {
      //       attributeName: 'goodsCode', //商品编码
      //       val: this.rowData.goodsCode,
      //       op: '=',
      //     },
      //   ],
      //   orderList: [],
      //   orderByColumn: '',
      //   orderType: '',
      //   hasCount: 'Y',
      // };
      // axios
      //   .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
      //   .then((res) => {
      //     if (res.code == 200) {
      //       this.tableData = res.data;
      //     }
      //   })
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-pagination__editor.el-input
      width 50px
</style>
